angular.module('unergie.main')
.filter('camundaProcess', () =>
    function (val) {
        const split = val.split(':')
        if (split.length > 1) {
            return `${split[0]}:${split[1]}`
        }
    },
)
